// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__iqJqq","ranges":"BmiRanges_ranges__3kBux"};